// extracted by mini-css-extract-plugin
export default {"switcherContainer":"TimeSwitcher_switcherContainer__sI1vP","switcherBtn":"TimeSwitcher_switcherBtn__QB4Ly"};